import React, { useState, useRef } from 'react';
import { Button, Modal, Dropdown } from 'react-bootstrap';
import PhotoCaptureModal from '../PhotoCaptureModal';

const ProductImageManager = ({ pictureBase64, onImageChange, productId, readOnly = false }) => {
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const fileInputRef = useRef(null);

  const convertToBase64 = (dataURL) => {
    return dataURL.split(',')[1];
  };

  const handleFileChange = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = convertToBase64(e.target.result);
        onImageChange(base64);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCameraPhoto = (dataURL) => {
    const base64 = convertToBase64(dataURL);
    onImageChange(base64);
    setShowCameraModal(false);
  };

  const confirmRemoveImage = () => {
    setShowDeleteConfirm(true);
  };

  const removeImage = () => {
    onImageChange(null);
    setShowDeleteConfirm(false);
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '50px' }}>
        {pictureBase64 ? (
          <div className="position-relative">
            <img 
              src={`data:image/jpeg;base64,${pictureBase64}`}
              alt="Producto"
              style={{ 
                width: '50px', 
                height: '50px', 
                objectFit: 'cover', 
                cursor: 'pointer',
                borderRadius: '4px',
                border: '1px solid #dee2e6'
              }}
              onClick={() => setShowImageModal(true)}
              title="Click para ver imagen completa"
            />
            {!readOnly && (
              <Button 
                variant="danger"
                size="sm"
                className="position-absolute"
                style={{
                  top: '-8px',
                  right: '-8px',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  padding: '0',
                  fontSize: '12px',
                  lineHeight: '1'
                }}
                onClick={confirmRemoveImage}
                title="Borrar imagen"
              >
                ×
              </Button>
            )}
          </div>
        ) : (
          !readOnly && (
            <Dropdown>
              <Dropdown.Toggle 
                variant="outline-secondary" 
                size="sm"
                style={{ fontSize: '12px' }}
              >
                📷
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => fileInputRef.current?.click()}>
                  📁 Subir archivo
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setShowCameraModal(true)}>
                  📸 Tomar foto
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => handleFileChange(e.target.files[0])}
      />

      <PhotoCaptureModal
        isOpen={showCameraModal}
        onClose={() => setShowCameraModal(false)}
        onPhotoTaken={handleCameraPhoto}
      />

      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Imagen del producto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {pictureBase64 && (
            <img 
              src={`data:image/jpeg;base64,${pictureBase64}`}
              alt="Producto"
              style={{ maxWidth: '100%', maxHeight: '500px' }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          {!readOnly && (
            <Button variant="danger" onClick={confirmRemoveImage}>
              Borrar imagen
            </Button>
          )}
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteConfirm} onHide={() => setShowDeleteConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar la imagen del producto?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={removeImage}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductImageManager;